var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M28.0542 9.58699L16.0008 16.5603L3.94751 9.58699C4.48084 8.60033 5.25418 7.73366 6.12084 7.25366L13.2408 3.30699C14.7608 2.45366 17.2408 2.45366 18.7608 3.30699L25.8808 7.25366C26.7475 7.73366 27.5208 8.60033 28.0542 9.58699Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.0008 16.5602V29.3336C15.0008 29.3336 14.0008 29.1202 13.2408 28.6936L6.12083 24.7469C4.5075 23.8536 3.1875 21.6136 3.1875 19.7736V12.2269C3.1875 11.3736 3.48083 10.4402 3.9475 9.58691L16.0008 16.5602Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8141 12.2269V19.7736C28.8141 21.6136 27.4941 23.8536 25.8807 24.7469L18.7607 28.6936C18.0007 29.1202 17.0007 29.3336 16.0007 29.3336V16.5602L28.0541 9.58691C28.5207 10.4402 28.8141 11.3736 28.8141 12.2269Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.a7b63e97e1e3aad4762961333ca886dc.svg";
export { ForwardRef as ReactComponent };